import type { FC } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Box } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { HighlightedText } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/components/highlighted-text/HighlightedText";
import { CollapsibleSection } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/components/side-panel/CollapsibleSection";
import type { IAiTrackerCampaign } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/types";

interface IPromptResponseSectionProps {
    responseText: string;
    campaign: IAiTrackerCampaign;
}

export const PromptResponseSection: FC<IPromptResponseSectionProps> = ({ campaign, responseText }) => {
    return (
        <CollapsibleSection
            title={translate("llm.prompts.side_panel.responses.title")}
            defaultExpanded={false}
            margin="16px 0 0 0"
        >
            <Box
                margin="12px 0 0 0"
                padding="12px 8px 12px 16px"
                borderRadius="4px"
                width="100%"
                background={colorsPalettes.carbon[25]}
            >
                <HighlightedText
                    fontVariant="body2"
                    color={colorsPalettes.carbon[500]}
                    text={responseText}
                    highlightedPhrase={campaign.brands || []}
                    isRtl={campaign.language?.isRtl}
                    highlightStyle={{
                        backgroundColor: colorsPalettes.yellow[300],
                    }}
                />
            </Box>
        </CollapsibleSection>
    );
};
